import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import * as $ from 'jquery';
declare var $: any;
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { environment } from './../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-personal-accident',
  templateUrl: './personal-accident.component.html',
  styleUrls: ['./personal-accident.component.css'],
  providers: [CommonService]
})
export class PersonalAccidentComponent implements OnInit {
  modalRef: BsModalRef;
  data: any = {};
  error: any;
  loading: boolean;
  quotesDetailsTable: boolean = false;
  sumInsured: boolean;
  prospectId: string;
  private sum: Array<any> = [];
  //sumValue: any;
  netPremium: any;
  policyTenure: any;
  accidentalDeath: any;
  permanentTotalDisability: any;
  permanentPartialDisability: any;
  medicalExpenses: any;
  accidentalHospitalization: any;
  fractures: any;
  noClaimHistory: any;
  filledUpProposalForm: any;
  quoteId: any;
  mobile: string;
  email: string;
  name: string;
  sumValue: string = '15 Lacs';
  contactEmail: string;
  contactMobile: any;
  contactName: string;
  updatedProspectIdPA: string;
  city: any;
  contactCity: any;
  medicalRadio: string = "Covered";
  accidentalBlock: boolean = true;
  cityList: any = [];
  noResult = false;
  partnerId: any;
  userDetails: any = {};
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private _location: Location, private serviceURLService: serviceURLService, private modalService: BsModalService, public commonService: CommonService) {
    this.userDetails.name = localStorage.getItem('name');
    this.userDetails.email = localStorage.getItem('email');
    this.userDetails.mobile = localStorage.getItem('mobileNumber');
    this.activatedRoute.queryParams.subscribe(params => {
      this.partnerId = params['partner'];
    });
  }

  ngOnInit() {
    this.prospectId = localStorage.getItem('prospectIdPA');
    this.getSumInsuredList();
    this.getCities();
    if (!this.partnerId) {
      this.partnerId = environment.production ? '997' : '997';
    }
  }


  createProspect() {
    this.data = {
      mobile: this.userDetails.mobile,
      prospectId: "",
      rmId: "",
      product: 129,
      email: this.userDetails.email,
      name: this.userDetails.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId ? this.partnerId : '',
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    // if (!this.prospectId) {
      this.serviceURLService.createProspect(this.data).subscribe((successData: any) => {
        // console.log("Prospect created successfully ",successData)
        this.prospectId = successData.data.prospectId;
        localStorage.setItem("prospectIdPA", this.prospectId);
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    // }
  }

  getSumInsuredList() {
    this.loading = true;

    this.serviceURLService.getSumInsuredList().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.sumInsured = successData.data.sumInsured
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }



  changeEventInRadioButton($event) {
    this.sumValue = $event
  }

  getMedicalExpensedValue() {
    if (this.medicalRadio == "Not Covered") {
      this.accidentalBlock = false;
      this.submitSumInsured();
    } else {
      this.accidentalBlock = true;
      this.submitSumInsured();
    }
  }

  submitSumInsured() {
   
    this.data = {
      mobile: this.userDetails.mobile,
      prospectId: "",
      rmId: "",
      product: 129,
      email: this.userDetails.email,
      name: this.userDetails.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId ? this.partnerId : '',
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    // if (!this.prospectId) {
      this.serviceURLService.createProspect(this.data).subscribe((successData: any) => {
        // console.log("Prospect created successfully ",successData)
        this.prospectId = successData.data.prospectId;
        localStorage.setItem("prospectIdPA", this.prospectId);

        this.data = {
          "sumInsured": this.sumValue,
          "medicalExpenses": this.medicalRadio,
          "prospectId": this.prospectId,
        }
        window.open(environment.pam2Url + '/individual-insurance/personal-accident-insurance/quote?prospect='
        + this.prospectId + '&sumValue=' + this.sumValue + '&medicalExpenses=' + this.medicalRadio);

        
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })

 
    // this.serviceURLService.getPAQuoteDetails(this.data).subscribe((successData: any) => {
    //   // this.router.navigate(['home']);
    //   //console.log("success Personal Accident Quote",successData);
    //   this.netPremium = successData.data.netPremium;
    //   this.policyTenure = successData.data.policyTenure;
    //   this.accidentalDeath = successData.data.accidentalDeath;
    //   this.permanentTotalDisability = successData.data.permanentTotalDisability;
    //   this.permanentPartialDisability = successData.data.permanentPartialDisability;
    //   this.medicalExpenses = successData.data.medicalExpenses;
    //   this.accidentalHospitalization = successData.data.accidentalHospitalization;
    //   this.fractures = successData.data.fractures;
    //   this.noClaimHistory = successData.data.noClaimHistory;
    //   this.filledUpProposalForm = successData.data.filledUpProposalForm;
    //   this.quoteId = successData.data.quoteId;
    //   this.loading = false;

    //   localStorage.setItem("PAQuoteId", this.quoteId);
    //   localStorage.setItem("sumInsured", this.sumValue);
    //   localStorage.setItem("religarePremium", this.netPremium);
    // }, errorData => {
    //   console.log("Oops..!! there is some error in prospect creation");
    //   if (errorData.error.status === 403) {
    //     this.error = errorData.error.message;
    //   }
    // })

  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  downloadPDF() {
    this.loading = true;
    // console.log("download pdf quote id ",this.quoteId)
    this.serviceURLService.downloadPdfPA(this.quoteId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.router.navigate(['home']);
      console.log("PDF downloaded successfully..!!", successData);

    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      var pdfRedirectionUrl = errorData.url
      window.open(pdfRedirectionUrl, "_blank")
      this.loading = false;
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  sendPDF() {
    this.loading = true;
    // console.log("download pdf quote id ",this.quoteId)
    this.serviceURLService.sendPDFEmailPA(this.quoteId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.router.navigate(['home']);
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in sending pdf", errorData);
      this.loading = false;
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  // updateProspect() {
  //   this.mobile = localStorage.getItem("mobileNumber")
  //   this.updatedProspectIdPA = localStorage.getItem("prospectIdPA");
  //   this.data = {
  //     "mobile": this.contactMobile,
  //     "prospectId": "",
  //     "rmId": "",
  //     "product": 129,
  //     "email": this.contactEmail,
  //     "name": this.contactName,
  //     "company": "",
  //     "location": this.contactCity,
  //     "designation": "",
  //     "comment": "",
  //     "partnerId": this.partnerId,
  //     "channel": "",
  //     "leadSource": "",
  //     "googleClickID": "",
  //     "couponCode": ""
  //   }
  //   if (this.contactMobile === this.mobile) {
  //     this.data.prospectId == this.updatedProspectIdPA;
  //   }
  //   else {
  //     //console.log("new prospect Id generated");
  //     this.data.prospectId == "";
  //   }
  //   this.serviceURLService.createProspect(this.data).subscribe((successData: any) => {
  //     this.modalRef.hide();
  //     this.router.navigate(['personal-accident-proposal']);
  //   }, errorData => {
  //     console.log("Oops..!! there is some error in prospect creation");
  //     if (errorData.error.status === 403) {
  //       this.error = errorData.error.message;
  //     }
  //   })
  // }

  // getContactDetails() {
  //   this.contactEmail = localStorage.getItem("email");
  //   this.contactMobile = localStorage.getItem("mobileNumber");
  //   this.contactName = localStorage.getItem("name")
  // }

  backtoFirstScreen() {
    if (this.quotesDetailsTable) {
      this.quotesDetailsTable = false;
    }
  }

  getCities() {
    this.loading = true;
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
      (success: any) => {
        this.loading = false;
        this.cityList = success.data.cityList;
      }, error => {
        this.loading = false;
      }
    )
  }

  selectCity(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }

  checkCityValue(event): void {
    this.noResult = this.commonService.checkCityValue(event, this.cityList);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


}
